export default __webpack_public_path__ + "static/media/susie7.bbf71796.jpg";